import React, { FormEvent, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../../api";
import "../../styles/Login.scss";
import logo from "../../assets/images/safari-logo.svg";

const ResetPassword = () => {
    const [searchParams] = useSearchParams();

    const token = searchParams.get("token") || "";
    const email = searchParams.get("email") || "";

    const [password, setPassword] = useState<string>("");
    const [passwordConfirmation, setPasswordConfirmation] =
        useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [error, setError] = useState<string>("");

    const handleSubmit = async (
        event: FormEvent<HTMLFormElement>
    ) => {
        event.preventDefault();

        setLoading(true);
        setMessage("");
        setError("");

        try {
            const response = await api.post("/admin/reset-password", {
                token,
                email,
                password,
                password_confirmation: passwordConfirmation,
            });

            setMessage(response.data.message);
        } catch (err: any) {
            console.error("Reset password failed:", err);

            const validationErrors = err.response?.data?.errors;

            if (validationErrors) {
                const firstError = Object.values(validationErrors)
                    .flat()
                    .find((error): error is string => typeof error === "string");

                setError(
                    firstError ||
                    "Unable to reset your password. Please try again."
                );
            } else {
                setError(
                    err.response?.data?.message ||
                    "Unable to reset your password. Please try again."
                );
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">

                    <div className="login-header">
                        <img src={logo} alt="Safari Vinegar" />
                    </div>

                    <div className="login-content">

                        <p>Reset your password</p>

                        {!message ? (
                            <form onSubmit={handleSubmit}>

                                <div className="form-group">
                                    <label htmlFor="password">
                                        New password
                                    </label>

                                    <input
                                        id="password"
                                        type="password"
                                        value={password}
                                        onChange={(event) =>
                                            setPassword(event.target.value)
                                        }
                                        autoComplete="new-password"
                                        required
                                        minLength={8}
                                        disabled={loading}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="password_confirmation">
                                        Confirm new password
                                    </label>

                                    <input
                                        id="password_confirmation"
                                        type="password"
                                        value={passwordConfirmation}
                                        onChange={(event) =>
                                            setPasswordConfirmation(
                                                event.target.value
                                            )
                                        }
                                        autoComplete="new-password"
                                        required
                                        minLength={8}
                                        disabled={loading}
                                    />
                                </div>

                                {error && (
                                    <div className="form-error">
                                        {error}
                                    </div>
                                )}

                                <div className="forgot-password-actions">
                                    <Link
                                        to="/admin-login"
                                        className="forgot-password-button"
                                    >
                                        Back to login
                                    </Link>

                                    <button
                                        type="submit"
                                        className="forgot-password-button"
                                        disabled={loading || !token || !email}
                                    >
                                        {loading
                                            ? "Resetting..."
                                            : "Reset password"}
                                    </button>
                                </div>

                            </form>
                        ) : (
                            <>
                                <div className="form-success">
                                    {message}
                                </div>

                                <div className="forgot-password-actions">
                                    <Link
                                        to="/admin-login"
                                        className="forgot-password-button"
                                    >
                                        Back to login
                                    </Link>
                                </div>
                            </>
                        )}

                    </div>

                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
